import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import logoIcon from "../assets/Logo.png";

export default function ResetPassword() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [newPassword, setNewPassword] = useState("");
  const [message, setMessage] = useState("");
  const [isError, setIsError] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!token) {
      setMessage("Token reset password tidak ditemukan.");
      setIsError(true);
    }
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setIsError(false);
    setLoading(true);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL || "http://localhost:5000"}/api/reset-password/${token}`,
        { password: newPassword }
      );

      if (response.data.success) {
        setMessage(response.data.message);
        setIsError(false);
        setNewPassword("");
        setTimeout(() => navigate("/login"), 2000);
      } else {
        setMessage(response.data.message || "Terjadi kesalahan");
        setIsError(true);
      }
    } catch (error) {
      setMessage(
        error.response?.data?.message || "Tidak dapat terhubung ke server"
      );
      setIsError(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      {/* Left branding panel */}
      <div className="auth-left">
        <div className="auth-left-circle auth-left-circle-1" />
        <div className="auth-left-circle auth-left-circle-2" />

        <div className="auth-brand" style={{ position: "relative", zIndex: 1 }}>
          <div className="auth-brand-row"><img src={logoIcon} alt="AiDuNode" className="auth-brand-icon" /><span className="auth-brand-name">AiDuNode</span></div>
          <h2 className="auth-left-title">
            Buat Password<br />Baru Kamu! 🔐
          </h2>
          <p className="auth-left-desc">
            Masukkan password baru yang kuat dan mudah diingat.
            Setelah berhasil, kamu bisa langsung masuk ke akun.
          </p>

          <div className="auth-left-chips">
            <span className="auth-left-chip">🔒 Aman &amp; Terenkripsi</span>
            <span className="auth-left-chip">✅ Langsung Aktif</span>
          </div>
        </div>

        <div className="auth-left-footer">
          © 2026 AiDuNode · Universitas Negeri Malang
        </div>
      </div>

      {/* Right form panel */}
      <div className="auth-right">
        <div className="auth-form-wrap">
          <div className="auth-form-header">
            <h1>Password Baru</h1>
            <p>Masukkan password baru yang ingin kamu gunakan untuk login.</p>
          </div>

          {!token ? (
            <div className="auth-message error">
              ⚠️ Token reset password tidak valid atau sudah kadaluarsa.
            </div>
          ) : (
            <form className="auth-form" onSubmit={handleSubmit}>
              <div className="auth-input-group">
                <label className="auth-input-label">Password Baru</label>
                <input
                  className="auth-input"
                  type="password"
                  placeholder="Min. 6 karakter"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  minLength={6}
                  required
                />
              </div>

              <button
                type="submit"
                className="btn btn-primary btn-full btn-lg"
                disabled={loading}
              >
                {loading ? "⏳ Menyimpan..." : "Simpan Password Baru →"}
              </button>
            </form>
          )}

          {message && token && (
            <div className={`auth-message ${isError ? "error" : "success"}`}>
              {isError ? "⚠️" : "✅"} {message}
            </div>
          )}

          <p className="auth-links">
            <a href="/login">← Kembali ke Login</a>
          </p>
        </div>
      </div>
    </div>
  );
}
